module.exports = __webpack_public_path__ + "img/Hotmart-8-pt.d622e9a4.png";